import { AppProviders } from '@/app/AppProviders';

export function App() {
  return <AppProviders />;
}

export default App;
